<template>
  <layout-vertical>

    <router-view />

    <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    />

  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from '@themeConfig'
import { refreshSuggestionBadge } from '@/views/content/suggestionBadge'

export default {
  components: {
    AppCustomizer,
    LayoutVertical,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
      suggestionBadgeIntervalId: null,
    }
  },
  created() {
    // Бэдж «Предложка»: сразу при входе и далее раз в 5 минут.
    refreshSuggestionBadge()
    this.suggestionBadgeIntervalId = setInterval(refreshSuggestionBadge, 5 * 60 * 1000)
  },
  beforeDestroy() {
    clearInterval(this.suggestionBadgeIntervalId)
  },
}
</script>
